<template>
  <v-data-table
    :headers="headers"
    :items="travelServiceOrders"
    :sort-by.sync="pagination.sortBy"
    :sort-desc.sync="pagination.descending"
    :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
    class="table-less-padding"
  >
    <template #item="props">
      <tr>
        <td class="text-no-wrap">{{ props.item.created_at }}</td>
        <td class="text-no-wrap">{{ props.item.created_by_name }}</td>
        <td>
          <v-row>
            <div v-for="travelServiceItem of props.item.travel_service_items" :key="travelServiceItem.id" class="ma-1">
              <travel-service-order-item-chip :travel-service-order-item="travelServiceItem" />
            </div>
          </v-row>
        </td>
        <td class="text-center">
          <span class="mx-1" style="text-align: center;">
            <order-chip :status="props.item.status" />
          </span>
        </td>
        <td class="text-no-wrap">
          <v-tooltip bottom v-if="unpin">
            <template #activator="{on}">
              <v-btn @click="$emit('unpin', props.item.id)" icon v-on="on">
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            {{ $t("global.unAssign") }}
          </v-tooltip>
          <v-tooltip bottom v-if="props.item.created_by_id === $store.state.Auth.userProperties.user_id || $store.getters.hasPermission('travelOrder')">
            <template #activator="{on}">
              <v-btn
                @click="$emit('edit', props.item.id)"
                icon
                v-on="on"
                v-if="
                  props.item.status === serviceStatus.STATUS_CREATED ||
                    props.item.status === serviceStatus.STATUS_PARTLY_COMPLETED ||
                    props.item.status === serviceStatus.STATUS_SEND
                "
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </template>
            {{ $t("travelService.goToOrderDetail") }}
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              props.item.status === serviceStatus.STATUS_SEND &&
                ($store.state.Auth.userProperties.user_id === props.item.created_by_id || $store.getters.hasPermission('travelOrder'))
            "
          >
            <template #activator="{on}">
              <v-btn @click="$emit('choose-offer', props.item.id)" icon v-on="on">
                <v-icon>fa-clipboard-list</v-icon>
              </v-btn>
            </template>
            {{ $t("travelService.chooseOffer") }}
          </v-tooltip>
          <cancellation-component :travel_service="props.item" @changed="$emit('changed')" />
          <v-tooltip bottom v-if="props.item.can_be_accepted">
            <template #activator="{on}">
              <v-btn @click="$emit('approval', props.item.id)" icon v-on="on">
                <v-icon>fa-clipboard-check</v-icon>
              </v-btn>
            </template>
            {{ $t("travelService.approvalForm") }}
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              [serviceStatus.STATUS_COMPLETE, serviceStatus.STATUS_CANCELLATION_REQUEST].includes(props.item.status) &&
                ($store.getters.isAdmin || props.item.can_view_vouchers)
            "
          >
            <template #activator="{on}">
              <v-btn @click="$emit('booked', props.item.id)" icon v-on="on">
                <v-icon>fa-ticket-alt</v-icon>
              </v-btn>
            </template>
            {{ $t("travelService.tickets") }}
          </v-tooltip>
          <template v-for="item of props.item.travel_service_items">
            <v-tooltip
              :key="item.id"
              bottom
              v-if="
                [itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK, itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER].includes(item.status) &&
                  (props.item.created_by_id === $store.state.Auth.userProperties.user_id || $store.getters.hasPermission('travelOrder'))
              "
            >
              <template #activator="{on}">
                <v-btn @click="$emit('message', item.id)" icon v-on="on">
                  <v-icon>fa-comment-dots</v-icon>
                </v-btn>
              </template>
              {{ $t("travelService.messageRequest") }}
            </v-tooltip>
          </template>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { serviceStatus, itemsStatus } from "../../staticData/ServiceOrder";
import TravelServiceOrderItemChip from "../../components/TravelService/Chips/TravelServiceOrderItemChip";
import OrderChip from "../../components/TravelService/OrderChip";
import CancellationComponent from "./CancellationComponent";

export default {
  name: "OrderListDataTable",
  components: { CancellationComponent, TravelServiceOrderItemChip, OrderChip },
  data: () => ({
    serviceStatus: serviceStatus,
    itemsStatus: itemsStatus,
    pagination: { sortBy: "created_at", descending: true }
  }),
  props: {
    travelServiceOrders: { required: true, type: Array },
    unpin: { required: false, type: Boolean, default: false }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("travelService.headers.createdAt"),
          value: "created_at"
        },
        {
          text: this.$t("travelService.headers.createdBy"),
          value: "created_by_name"
        },
        {
          text: this.$t("travelService.headers.services"),
          value: "param",
          sortable: false
        },
        {
          text: this.$t("travelService.headers.allOrderStatus"),
          value: "status"
        },
        { text: "", value: "actions", sortable: false }
      ];
    }
  }
};
</script>

<style scoped></style>
